export enum PROJECT_STATE {
  COMPLETED = 'Completed',
  IN_PROGRESS = 'Progress',
  NOT_STARTED = 'NotStarted',
}
